import * as React from 'react';
import { EditState, EditProps, BaseRouteProps } from '../../interfaces';
import { Question } from '../../models';
import { CharacteristicScoreDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { TopNavMenu } from '../navigation/TopNavMenu';
import { CharacteristicScoreForm } from './CharacteristicScoreForm';
import { LoadingIndicator } from '../../components';

export class CharacteristicScoreEdit extends React.Component<BaseRouteProps<EditProps>, EditState<Question>> {
    private characteristicScoreDataService = new CharacteristicScoreDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<EditProps>) {
        super(props);

        this.state = {
            originalEntity: undefined
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {
        const id = this.props.match.params.id;

        if (id) {
            this.characteristicScoreDataService.get(id).then((question: Question) => {
                question.questionTexts = question.questionTexts || [];
                question.characteristicScores = question.characteristicScores || [];
                this.setState({ originalEntity: question });
            });
        }
    }

    public render() {
        if (!this.state.originalEntity) {
            return <LoadingIndicator />;
        }

        return (
            <div>
                <TopNavMenu open={true} />

                <div className="content-header">
                    <div className="content-container">
                        <NavLink to={'/question'}>
                            <span className="glyphicon glyphicon-triangle-left" /> back
                        </NavLink>
                        <h1>Edit Characteristic Score</h1>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <CharacteristicScoreForm defaultValues={this.state.originalEntity} submit={this.save} notificationService={this.props.notificationService} />
                    </div>
                </div>
            </div>);
    }

    private save(values: any) {
        this.characteristicScoreDataService.update(values).then((success) => {
            // this.props.history.push('/question');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/characteristicscore/CharacteristicScoreEdit.tsx